import {UIHomepageAdView} from './UIHomepageAdView'
import {UIHomepageStoreAdController} from './UIHomepageStoreAdController'

export class UIHomepageRightStoreAdController extends UIHomepageStoreAdController {
    protected createAdView() {
        this.view = new UIHomepageAdView(false)
    }
}
